"use client";

import React, { useState, useCallback, useRef } from "react";

const placementStyles = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2",
};

/**
 * OverlayTrigger - Shows overlay (e.g. Tooltip) on hover/focus.
 */
export function OverlayTrigger({
  children,
  overlay,
  placement = "top",
  delay = 0,
  delayShow = delay,
  delayHide = delay,
  ...props
}) {
  const [show, setShow] = useState(false);
  const timeoutRef = useRef(null);

  const showOverlay = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setShow(true), delayShow);
  }, [delayShow]);

  const hideOverlay = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setShow(false), delayHide);
  }, [delayHide]);

  const overlayContent = typeof overlay === "function"
    ? overlay({ show, placement })
    : overlay;

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={showOverlay}
      onMouseLeave={hideOverlay}
      onFocus={showOverlay}
      onBlur={hideOverlay}
      {...props}
    >
      {children}
      {show && overlayContent}
    </span>
  );
}
